import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";

const LoadStaffingDetails = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/Staffing/GetStaffingDetails', {
        houseCode: defaultSite.houseCode[0],
        workDate: date,
        siteId: defaultSite.id + ""
    })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }
 
        offlineService.removeOfflineBySite(defaultSite.id, "StaffingDetails");
        offlineService.addOffline(defaultSite.id, "StaffingDetails", result);
    },
    (error) => {
        console.log(error);
    });
};

export { LoadStaffingDetails };
